import { CubeIcon, LockClosedIcon } from "@heroicons/react/24/outline";
import { formatDate } from "../../../../lib/utils";
import { useState } from "react";
import CreateSharingInvitationModal from "../../../../components/CreateSharingInvitationModal";
import { DocumentFragment } from "../../../../__generated__/graphql";
import DocumentSharedWith from "./components/DocumentSharedWith";
import DocumentDetailsModal from "./components/DocumentDetailsModal";
import { FaRegCalendar, FaStar } from "react-icons/fa6";

interface DocumentItemProps {
  document: DocumentFragment;
  isSharable?: boolean;
}

export default function DocumentItem({ document }: DocumentItemProps) {
  const isDocumentSent =
    document.originalSenderOrganizationId !== null ||
    document.originalSenderUserOrganization !== null;

  const [documentDetailsModalIsOpen, setDocumentDetailsModalIsOpen] =
    useState(false);
  const [invitationModalIsOpen, setInvitationModalIsOpen] = useState(false);

  const documentItemSubtitle = () => {
    if (document.activityId && document.isPublic) {
      return (
        <div className="text-sm text-secondary flex items-center gap-1">
          <FaRegCalendar className="w-4 h-4" />
          {document.activityName}
        </div>
      );
    } else if (document.eventName && document.isPublic) {
      return (
        <div className="text-sm text-secondary flex items-center gap-1">
          <FaStar className="w-4 h-4" />
          {document.eventName}
        </div>
      );
    } else if (document.projectName && document.isPublic) {
      return (
        <div className="text-sm text-secondary flex items-center gap-1">
          <CubeIcon className="w-4 h-4" />
          {document.projectName}
        </div>
      );
    } else if (
      (document.documentSharings !== null &&
        document.documentSharings !== undefined &&
        document.documentSharings.length > 0) ||
      (document.documentGroupSharings !== null &&
        document.documentGroupSharings !== undefined &&
        document.documentGroupSharings.length > 0)
    ) {
      return (
        <DocumentSharedWith
          documentSharings={document.documentSharings ?? []}
          documentGroupSharings={document.documentGroupSharings ?? undefined}
        />
      );
    } else {
      return (
        <div className="flex items-center gap-1">
          <LockClosedIcon className="w-4 h-4 text-secondary" />
          <div className="text-sm text-secondary">Document privé</div>
        </div>
      );
    }
  };

  const documentSubtitle = () => {
    if (isDocumentSent) {
      return `Envoyé par ${document.originalSenderUserOrganization?.name}`;
    } else {
      return `Créé le ${formatDate(document.createdAt)} par ${
        document.ownerUserOrganization?.name
      }`;
    }
  };

  return (
    <>
      <DocumentDetailsModal
        isOpen={documentDetailsModalIsOpen}
        onClose={() => setDocumentDetailsModalIsOpen(false)}
        onInvitationModalOpen={() => {
          setInvitationModalIsOpen(true);
        }}
        document={document}
      />

      <CreateSharingInvitationModal
        isModalOpen={invitationModalIsOpen}
        onClose={() => setInvitationModalIsOpen(false)}
      />

      <div
        data-testid="document-item"
        className="w-full flex justify-between p-4 rounded-md items-center cursor-pointer bg-card hover:bg-card/40 border border-border transition-all duration-300 text-primary"
        onClick={() => {
          setDocumentDetailsModalIsOpen(true);
        }}
      >
        <div className="flex flex-col gap-1">
          <div className="text-sm text-border">{documentSubtitle()}</div>
          <div className="text-sm font-bold">{document.title}</div>

          {documentItemSubtitle()}
        </div>
      </div>
    </>
  );
}
